import { defineMessage } from '../../translations/defineMessage';
import { Cabin } from '../../types';

export const getTranslatedCabin = (key: string): string | undefined =>
  ({
    [Cabin.UnknownCabin]: undefined,
    [Cabin.Economy]: defineMessage('Economy'),
    [Cabin.PremiumEconomy]: defineMessage('Premium economy'),
    [Cabin.Business]: defineMessage('Business'),
    [Cabin.First]: defineMessage('First'),
  }[key]);
